module.exports = __webpack_public_path__ + "static/img/m_name.1a1376e.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/oo/m_name.png
// module id = wLwt
// module chunks = 7